/**
 * A label map from a module manifest, rendered in the language at hand
 * (MODULES §2.4).
 *
 * Module strings do not live in `en.ts`: they come with the release, keyed by
 * two-letter language code, and `en` is required of every one of them. So the
 * rule is the manifest's own — the current language if it has it, English
 * otherwise — and it is written once here rather than at each of the dozen
 * places that render a module's name.
 */
export function localized(
  map: Record<string, string> | undefined | null,
  lang: string,
  fallback = "",
): string {
  if (!map) return fallback;
  const text = map[lang] ?? map.en ?? Object.values(map)[0];
  return typeof text === "string" && text ? text : fallback;
}
